export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSirkaPneu';
export const NAME = 'SirkaPneu';
